export { default } from "./useGetPolls";
